import {getMissingFeaturesAndClickThem} from "./lookNavigation/lookNavigationFunctions";
import {checkIfLookFeaturesReceived} from "../../api/look-api";
import {
  allSafetyPackageGroups,
  shouldUseSafetyPackage,
  updateFeatureGroupsWithNewSide
} from "../bvSceneComponent/core/safetyPackageSidesLogic";

export const featureCanChangeShowerSize = (feature) => {
  if (!feature) {
    return false
  }
  return feature.partId === "shower_pan_combo" || feature.partId === "walk_in_tub" || feature.partId === "shower_body"
}

const neededFeatureGroupsToCheckOnShowerSizeChange = document.kvConfig.toolVersion === 5
  ? ["shower_pan_combo", "shower_interior_wall", "left_wall", "right_wall", "bathroom_floor", "shower_fixture"]
  : ["shower_wall", "split_wall", "left_wall_splitter", "bathroom_floor", "front_wall", "shower_fixture"];

/**
 * Checks needed features on ShowerSize change
 * @param clickedFeature {object}
 * @returns {promise}
 */
export const searchForSameNameWallsBeforeFeatureApply = async (clickedFeature) => {
  if (!clickedFeature.getParent) {
    return
  }
  const showerPanComboParent = clickedFeature.getParent();
  if (clickedFeature.metaData["ShowerSize"] && clickedFeature.metaData["ShowerSize"][0] && showerPanComboParent.activeFeature
    && showerPanComboParent.activeFeature.metaData["ShowerSize"]
    && (showerPanComboParent.activeFeature.metaData["ShowerSize"][0] !== clickedFeature.metaData["ShowerSize"][0])) {

    const showerParent = showerPanComboParent.getParent();
    const layout = showerParent.layout;

    if (layout.isNewLayout && !showerPanComboParent.allFeaturesReceived) {
      // we can click on custom feature, like shower size on rebath,
      // so we need to get all features from BE to have all needed features to switch shower size
      await checkIfLookFeaturesReceived(showerPanComboParent);
    }

    let missingFeatures = [];
    const newSizeCondition = {
      propName: "ShowerSize",
      propValue: clickedFeature.metaData["ShowerSize"][0]
    };
    neededFeatureGroupsToCheckOnShowerSizeChange.forEach((partId) => {
      const featureGroup = layout.getFeatureGroupByPartId(partId);
      if (featureGroup && featureGroup.activeFeature && !featureGroup.activeFeature.matchesMetaForCondition(newSizeCondition)) {
        const navigationItemName = featureGroup.activeFeature.getSplittedFeatureName();
        const newConditions = featureGroup.getArrayOfConditions().map(condition => {
          if (condition.propName === "ShowerSize") {
            return newSizeCondition
          }
          return condition
        });
        const featureFound = featureGroup.features.find(feature => {
          return (feature.getSplittedFeatureName() === navigationItemName) && feature.matchesMetaForArrayOfConditions(newConditions)
        });
        if (!featureFound &&
          !(featureGroup && featureGroup.alreadyRequestedFeatureNames && featureGroup.alreadyRequestedFeatureNames.includes(navigationItemName))) {
          missingFeatures.push({
            relatedItem: featureGroup,
            navigationItemName,
            setCurrentFeature: false
          })
        }
      }
    });
    if (missingFeatures.length) {
      await getMissingFeaturesAndClickThem(missingFeatures)
    }
  }

  return Promise.resolve();
}

export const applyBathroomLogicAfterFeaturePositionClick = (matchingPositionFeature) => {
  const parent = matchingPositionFeature.getParent();
  if (matchingPositionFeature.notAvailableInVisualizer || !parent.layerPositions || !matchingPositionFeature.metaData.layerPosition) {
    return
  }
  const position = matchingPositionFeature.metaData.layerPosition;
  if (parent.isShowerCommonGroup) { // tool version 6 for now only
    parent.checkSameShowerPositionForAnotherFeatureGroup(position, matchingPositionFeature)
  }
  if (parent.partId === "handle_shower_valve" && parent.checkForOneMountType) {
    parent.checkForOneMountType(matchingPositionFeature);
  }
  // const checkRelatedFeatureGroups = ["grab_bar", "soap_dish", "shower_seats", "large_corner_seat"];
  const checkRelatedFeatureGroups = ["shower_seats", "large_corner_seat"];
  if (checkRelatedFeatureGroups.includes(parent.partId)) {
    matchingPositionFeature.handleClick(true); // set active feature (for seats, to match seatPads)
    parent.checkRelatedFeatureGroupPositions(position, matchingPositionFeature);
    // if (parent.partId === "grab_bar") {
    //   parent.checkCurrentPositions(position);
    // }
  }
  if (allSafetyPackageGroups.includes(parent.partId) && shouldUseSafetyPackage(parent)) {
    updateFeatureGroupsWithNewSide(matchingPositionFeature, position);
  }
  if (parent.checkCenterGrabWall) {
    parent.checkCenterGrabWall(position);
  }
}
